import { Injectable, signal } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class SideNavigationStateService {
  readonly expanded = signal(true);

  toggle(): void {
    this.expanded.update((expanded) => !expanded);
  }
}
